// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Tabs__Wrapper_3Yhtl","Tabs":"Tabs__Tabs_jaqmh","Tab":"Tabs__Tab_8LLeC","Items":"Tabs__Items_2ZXYA","Quarter":"Tabs__Quarter_vgyFV"};